export type PlanDTO = {
  title: string;
  unit: Unit;
  value: number;
  idle_grace_period: number | string;
  idle_value: number | string;
  partnership_id: string;
};

export type PlanForm = {
  title: string;
  unit: string;
  value: string;
  idle_grace_period: string;
  idle_value: string;
  partnership_id: string;
};

export enum Units {
  kwh = "kwh",
  hour = "hour",
}

export type Unit = keyof typeof Units;
